<template>
  <div>
    <div v-if="showPlaceHolder" :style="stylePlaceHolder" />
    <div
      ref="scroll-affix"
      :style="affixStyle"
      :class="
        showPlaceHolder
          ? 'scroll-affix-container'
          : 'scroll-affix-container pd0'
      "
    >
      <slot
        v-bind="{
          affixed: getAffixed,
        }"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'VabAffix',
    props: {
      offsetTop: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        affixStyle: {
          position: 'initial',
          top: 'initial',
        },

        // 占位区域样式
        stylePlaceHolder: {},

        // 占位区域
        showPlaceHolder: false,

        // 实例
        instance: '',

        // 用于记录实例的初始状态下的位置
        defaultInstancePosition: '',
      }
    },
    computed: {
      getAffixed() {
        return this.affixStyle.position === 'fixed'
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.instance = this.$refs['scroll-affix']
        this.createAffix()
      })
    },
    beforeDestroy() {
      document
        .getElementById('app')
        .removeEventListener('scroll', this.scrollListener)
    },
    methods: {
      getInstanceRect() {
        return this.instance.getBoundingClientRect()
      },

      getContainerScrollTop() {
        return document.getElementById('app').scrollTop
      },

      createAffix() {
        this.defaultInstancePosition = this.getInstanceRect().top
        this.beforeListener()
        document
          .getElementById('app')
          .addEventListener('scroll', this.scrollListener)
      },

      setFixedForInstance() {
        const instanceRect = this.getInstanceRect()
        // css 有padding了 高度删除了
        this.affixStyle = {
          position: 'fixed',
          top: `${this.offsetTop}px`,
          zIndex: '999',
          width: `${instanceRect.width}px`,
          border: '1px solid #ccc',
          'border-radius': '5px',
          'box-shadow': '0 2px 12px 0 rgb(0 0 0 / 10%)',
        }
        this.$emit('change', true)
      },

      // 用于设置实例在固定后的空白占位
      setPlaceHolder() {
        this.showPlaceHolder = true
        const instanceRect = this.getInstanceRect()
        this.stylePlaceHolder = {
          width: `${instanceRect.width}px`,
          height: `${instanceRect.height}px`,
        }
      },
      beforeListener() {
        // 若下一次进入页面发现滚动条所处位置已经超过了实例，则立即固定
        if (this.defaultInstancePosition < this.offsetTop) {
          this.setFixedForInstance()
          this.setPlaceHolder()
        }

        this.defaultInstancePosition =
          this.getContainerScrollTop() + this.defaultInstancePosition
      },
      scrollListener() {
        const offsetTop = this.getInstanceRect().top
        // 当实例距离顶部的距离刚好接近(0px+设置的 top 距离)时，则立即固定
        if (offsetTop < this.offsetTop) {
          this.setFixedForInstance()
          this.setPlaceHolder()
        }

        const containerScrollTop = this.getContainerScrollTop()
        const isArrivalDefault =
          this.defaultInstancePosition - this.offsetTop >= containerScrollTop

        // 当实例的初始位置减去设置的 top 距离刚好接近滚动条滚过的距离时（即一直在向上滚动）&& 实例已经在固定状态，则取消固定
        if (isArrivalDefault && this.affixStyle.position === 'fixed') {
          this.affixStyle = {}
          this.showPlaceHolder = false
          this.stylePlaceHolder = {}
          this.$emit('change', false)
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .scroll-affix-container {
    position: initial;
    top: initial;
    background-color: #fff;
    padding: 10px;
  }

  .pd0 {
    padding: 0;
    padding-right: 50px;
  }
</style>
